module.exports = __webpack_public_path__ + "img/manual3.be9aec85.jpg";